module.exports = __webpack_public_path__ + "static/media/img2-4.7368d52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/diff/img2-4.png
// module id = 1273
// module chunks = 3